import { Box, Stack } from '@mui/material'
import { roundingNumber } from 'components/shared/processes'
import { IGroupEntity } from 'models'
import moment from 'moment'
import { COLORS } from 'styles/colors'
import LinearProgressBar from 'ui/linear-progress/LinearProgressBar'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import { ReactComponent as FarmTable } from '../../../../assets/farm_table.svg'

type LinearChartProps = IGroupEntity & {
	showTitle?: boolean
}

export const LinearChart = (props: LinearChartProps) => {
	const isIssueFoodtable = props?.foodtable?.camera_issue
	const hasNoData = Boolean(
		!props.foodtable || props.foodtable.no_data || isIssueFoodtable,
	)
	const hasVolumeValues =
		typeof props.foodtable?.r_feed === 'number' &&
		typeof props.foodtable?.ur_feed === 'number'
	const isEmptyByVolume =
		hasVolumeValues &&
		Number(props.foodtable?.r_feed) + Number(props.foodtable?.ur_feed) < 1
	const isFoodTableEmpty = hasNoData
		? false
		: hasVolumeValues
			? isEmptyByVolume
			: (props.foodtable?.reachable_percent ?? 0) <= 2

	const unreachablePercent = roundingNumber(
		props.foodtable?.unreachable_percent ?? 0,
		0,
	)
	const reachablePercent = roundingNumber(
		props.foodtable?.reachable_percent ?? 0,
		0,
	)
	const totalPercent = isFoodTableEmpty
		? 0
		: roundingNumber(props.foodtable?.total_percent ?? 0, 0)

	const statusTime = !hasNoData && (
		<TypographySecondary sx={{ textAlign: 'end' }}>
			Состояние на сегодня {moment().format('HH:mm')}
		</TypographySecondary>
	)
	const statusTotal = !hasNoData && (
		<TypographySecondary sx={{ textAlign: 'end' }}>
			Итого корма после раздачи: {totalPercent}%
		</TypographySecondary>
	)

	return (
		<Box display='flex' flexDirection='column' gap='7px'>
			{props.showTitle && (
				<Stack
					direction='row'
					alignItems='center'
					justifyContent='space-between'
					sx={{ mb: '10px' }}
				>
					<TypographyPrimary16Bold>
						Доступность корма на кормовом столе
					</TypographyPrimary16Bold>
					{statusTime}
				</Stack>
			)}
			{props.showTitle ? (
				<Stack
					direction='row'
					alignItems='center'
					justifyContent='space-between'
					sx={{ columnGap: '16px' }}
				>
					<Stack
						direction='row'
						alignItems='center'
						gap='4px'
						sx={{ flexShrink: 0 }}
					>
						<FarmTable />
						<TypographySecondary14>Кормовой стол</TypographySecondary14>
					</Stack>
					{statusTotal}
				</Stack>
			) : (
				<Stack gap='2px'>
					{statusTime && (
						<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
							{statusTime}
						</Box>
					)}
					<Stack
						direction='row'
						alignItems='center'
						justifyContent='space-between'
						sx={{ columnGap: '16px' }}
					>
						<Stack
							direction='row'
							alignItems='center'
							gap='4px'
							sx={{ flexShrink: 0 }}
						>
							<FarmTable />
							<TypographySecondary14>Кормовой стол</TypographySecondary14>
						</Stack>
						{statusTotal}
					</Stack>
				</Stack>
			)}

			<LinearProgressBar
				reachable={props.foodtable?.reachable_percent ?? 0}
				unreachable={props.foodtable?.unreachable_percent ?? 0}
				noData={hasNoData}
				empty={isFoodTableEmpty}
			/>
			<Box
				sx={{
					position: 'relative',
					width: '100%',
					height: '16px',
					marginTop: '6px',
				}}
			>
				{hasNoData ? (
					<TypographySecondary14>Нет данных</TypographySecondary14>
				) : !isFoodTableEmpty ? (
					<>
						<TypographySecondary14
							sx={{ color: COLORS.health, position: 'absolute', left: 0 }}
						>
							{unreachablePercent}%
						</TypographySecondary14>
						{reachablePercent > 0 && (
							<TypographySecondary14
								sx={{
									color: COLORS.success,
									position: 'absolute',
									left: `${Math.min(unreachablePercent + reachablePercent, 100)}%`,
									transform: 'translateX(-100%)',
								}}
							>
								{reachablePercent}%
							</TypographySecondary14>
						)}
					</>
				) : (
					<TypographySecondary14 sx={{ color: COLORS.error }}>
						Пустой
					</TypographySecondary14>
				)}
			</Box>
		</Box>
	)
}
